/* ==========================================================================
   Vitalyx — comportamiento propio. Vanilla, sin librerias.
   Un init por componente; cada uno sale solo si su elemento no existe.
   ========================================================================== */
(function () {
  'use strict';

  // Cada seccion incluye este archivo con SU PROPIA etiqueta <script>. El
  // navegador lo descarga una sola vez, pero lo EJECUTA una vez por etiqueta:
  // sin esta guarda cada boton acababa con un manejador por seccion de la
  // pagina, y la cantidad del producto subia de golpe (1 -> 3 -> 7...) en vez
  // de uno en uno. Lo mismo afectaba a los desplegables y a las flechas de
  // las opiniones.
  if (window.__vtScriptLoaded) return;
  window.__vtScriptLoaded = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Marca un elemento como ya preparado. Devuelve false si ya lo estaba, para
  // que al recargar una seccion en el editor de Shopify no se dupliquen los
  // manejadores de lo que ya estaba en pantalla.
  function once(el, key) {
    var k = 'vtInit' + key;
    if (el.dataset[k] === '1') return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ------------------------------------------------ entradas al hacer scroll */
  function initReveal() {
    var items = document.querySelectorAll('.vt-reveal, .vt-reveal-img, .vt-curtain, .vt-word');
    if (!items.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('vt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vt-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { if (once(el, 'Rev1')) io.observe(el); });
  }

  /* --------------------------------------------------------------- parallax */
  function initParallax() {
    var layers = document.querySelectorAll('[data-vt-parallax]');
    if (!layers.length || REDUCED) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      layers.forEach(function (el) {
        var host = el.closest('section') || el.parentElement;
        var r = host.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var amount = parseFloat(el.getAttribute('data-vt-parallax')) || 12;
        var progress = (r.top + r.height / 2 - vh / 2) / vh; // -1 .. 1
        if (progress > 1) progress = 1;
        if (progress < -1) progress = -1;
        // La escala tiene que dar de si MAS que el desplazamiento maximo o
        // asoma el fondo por arriba/abajo. Con el orden translate->scale el
        // desplazamiento es en pixeles de pantalla, asi que basta con que el
        // sobrante por lado ((s-1)/2 * alto) supere ese desplazamiento.
        var scale = 1 + (amount * 2.4) / 100;
        var shift = -progress * (amount / 100) * el.offsetHeight;
        el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
      });
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }
    if (!window.__vtParallaxBound) {
      window.__vtParallaxBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    frame();
  }

  /* ------------------------------------------------------------ marquesina */
  function initMarquee() {
    document.querySelectorAll('.vt-marquee__track').forEach(function (track) {
      if (track.dataset.vtCloned === '1') return;
      track.dataset.vtCloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* --------------------------------------- ingredientes: visual pegajoso */
  function initIngredients() {
    document.querySelectorAll('[data-vt-ing]').forEach(function (root) {
      if (!once(root, 'Ing')) return;
      var imgs = root.querySelectorAll('.vt-ing__sticky img');
      var items = root.querySelectorAll('.vt-ing__item');
      if (!imgs.length || !items.length) return;
      if (imgs[0]) imgs[0].classList.add('is-on');
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.getAttribute('data-idx'), 10) || 0;
          imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        });
      }, { threshold: 0.4, rootMargin: '-25% 0px -35% 0px' });
      items.forEach(function (it) { io.observe(it); });
    });
  }

  /* -------------------------------------------------------- cifras animadas */
  function initCounters() {
    var els = document.querySelectorAll('[data-vt-count]');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-vt-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var raw = el.getAttribute('data-vt-count') || '';
        var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
        if (!m) { el.textContent = raw; return; }
        var pre = m[1], post = m[3];
        var target = parseFloat(m[2].replace(/,/g, '.'));
        var dec = (m[2].split(/[.,]/)[1] || '').length;
        var t0 = null, dur = 1500;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + (target * eased).toFixed(dec) + post;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { if (once(el, 'Count')) io.observe(el); });
  }

  /* --------------------------------------------------- carrusel de resenas */
  function initReviews() {
    document.querySelectorAll('[data-vt-carousel]').forEach(function (root) {
      if (!once(root, 'Rev')) return;
      var track = root.querySelector('.vt-rev__track');
      var prev = root.querySelector('[data-vt-prev]');
      var next = root.querySelector('[data-vt-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.vt-rev__card');
        if (!card) return 320;
        return card.getBoundingClientRect().width + 20;
      }
      function sync() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 6;
        next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 6;
      }
      // El desplazamiento suave y el ajuste por tarjetas (scroll-snap) se
      // pelean: el snap cancela la animacion y el carrusel volvia al sitio,
      // asi que las flechas no hacian nada. Se apaga el ajuste mientras dura
      // el movimiento y se vuelve a encender al terminar.
      // Ademas, `behavior: 'smooth'` no es fiable dentro de un contenedor con
      // ajuste por tarjetas (en algunos navegadores simplemente no se mueve),
      // asi que la animacion la hacemos nosotros y queda igual en todos.
      var animando = false;
      function mover(dir) {
        var desde = track.scrollLeft;
        var tope = track.scrollWidth - track.clientWidth;
        var hasta = Math.max(0, Math.min(tope, desde + dir * step()));
        if (hasta === desde) return;
        if (REDUCED) { track.scrollLeft = hasta; sync(); return; }
        track.style.scrollSnapType = 'none';
        animando = true;
        function terminar(pos) {
          animando = false;
          track.scrollLeft = pos;
          track.style.scrollSnapType = '';
          sync();
        }
        // Red de seguridad: si las animaciones no corren (pestana en segundo
        // plano, navegador que las congela...) el carrusel salta igualmente al
        // sitio en vez de quedarse clavado.
        var seguro = setTimeout(function () { if (animando) terminar(hasta); }, 700);
        var t0 = null, dur = 430;
        function anim(ts) {
          if (!animando) return;
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          track.scrollLeft = desde + (hasta - desde) * eased;
          if (p < 1) {
            requestAnimationFrame(anim);
          } else {
            clearTimeout(seguro);
            terminar(hasta);
          }
        }
        requestAnimationFrame(anim);
      }
      if (prev) prev.addEventListener('click', function () { mover(-1); });
      if (next) next.addEventListener('click', function () { mover(1); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();

      // arrastrar con el raton
      var down = false, x0 = 0, s0 = 0, moved = 0;
      track.addEventListener('mousedown', function (e) {
        down = true; moved = 0; x0 = e.pageX; s0 = track.scrollLeft;
        track.classList.add('is-drag');
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-drag');
      });
      track.addEventListener('mousemove', function (e) {
        if (!down) return;
        e.preventDefault();
        var d = e.pageX - x0;
        moved = Math.abs(d);
        track.scrollLeft = s0 - d;
      });
      track.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ----------------------------------------------------------- acordeones */
  function initAccordion() {
    document.querySelectorAll('.vt-acc__btn').forEach(function (btn) {
      if (!once(btn, 'Acc')) return;
      btn.addEventListener('click', function () {
        var item = btn.closest('.vt-acc__item');
        if (!item) return;
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* -------------------------------------------------- galeria del producto */
  function initGallery() {
    document.querySelectorAll('[data-vt-gallery]').forEach(function (root) {
      if (!once(root, 'Gal')) return;
      var imgs = root.querySelectorAll('.vt-pd__main img');
      var thumbs = root.querySelectorAll('.vt-pd__thumb');
      if (!imgs.length) return;
      function show(i) {
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      show(0);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
      });
    });
  }

  /* ------------------------------------------------- cantidad y variantes */
  function initQty() {
    document.querySelectorAll('[data-vt-qty]').forEach(function (root) {
      if (!once(root, 'Qty')) return;
      var input = root.querySelector('input');
      if (!input) return;
      root.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-step') === '-1' ? -1 : 1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + d);
          input.value = v;
        });
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-vt-variants]').forEach(function (root) {
      if (!once(root, 'Var')) return;
      var data;
      var holder = root.querySelector('[data-vt-variant-json]');
      if (!holder) return;
      try { data = JSON.parse(holder.textContent); } catch (err) { return; }
      if (!data || !data.length) return;

      var pills = root.querySelectorAll('.vt-pd__pill');
      var idInput = root.querySelector('[data-vt-variant-id]');
      var priceEl = root.querySelector('[data-vt-price]');
      var wasEl = root.querySelector('[data-vt-was]');
      var addBtn = root.querySelector('[data-vt-add]');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var soldText = root.getAttribute('data-sold-text') || 'Sold out';
      var addText = root.getAttribute('data-add-text') || 'Add to cart';

      // Los precios llegan ya formateados por la tienda (simbolo, separadores
      // y posicion correctos), asi que aqui solo se intercambian textos.
      function pick(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl && v.priceText) priceEl.textContent = v.priceText;
        if (wasEl) {
          if (v.hasWas && v.wasText) {
            wasEl.textContent = v.wasText;
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }
        if (addBtn) {
          addBtn.classList.toggle('is-disabled', !v.available);
          addBtn.disabled = !v.available;
          if (addLabel) addLabel.textContent = v.available ? addText : soldText;
        }
      }
      pills.forEach(function (p, i) {
        p.addEventListener('click', function () {
          pills.forEach(function (o) { o.classList.remove('is-on'); });
          p.classList.add('is-on');
          pick(data[i]);
        });
      });
      var start = 0;
      for (var i = 0; i < data.length; i++) { if (data[i].available) { start = i; break; } }
      if (pills.length) {
        pills.forEach(function (o) { o.classList.remove('is-on'); });
        if (pills[start]) pills[start].classList.add('is-on');
      }
      pick(data[start]);
    });
  }

  /* --------------------------------------------- comparador antes/despues */
  function initCompare() {
    document.querySelectorAll('[data-vt-compare]').forEach(function (root) {
      if (!once(root, 'Cmp')) return;
      var range = root.querySelector('.vt-ba__range');
      if (!range) return;

      function set(v) {
        var p = Math.max(0, Math.min(100, v));
        root.style.setProperty('--vt-pos', p + '%');
      }
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      set(parseFloat(range.value));

      // Arrastre con el dedo o el raton sobre la propia imagen. El <input type="range">
      // se queda solo para el teclado: su "pulgar" mide 2 px y con el dedo no hay
      // forma de agarrarlo, por eso en el movil no se podia arrastrar.
      var dragging = false;
      var tocado = false;

      function fromPointer(e) {
        var r = root.getBoundingClientRect();
        if (!r.width) return null;
        return ((e.clientX - r.left) / r.width) * 100;
      }
      function apply(e) {
        var v = fromPointer(e);
        if (v === null) return;
        set(v);
        range.value = Math.max(0, Math.min(100, v));
      }
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        try { root.releasePointerCapture(e.pointerId); } catch (err) {}
      }

      root.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        tocado = true; // corta el guino de entrada si aun estuviera corriendo
        try { root.setPointerCapture(e.pointerId); } catch (err) {}
        apply(e);
      });
      root.addEventListener('pointermove', function (e) {
        if (dragging) apply(e);
      });
      root.addEventListener('pointerup', endDrag);
      root.addEventListener('pointercancel', endDrag);

      // guino al entrar en pantalla: el asa se desliza hasta su sitio para que
      // se entienda que se puede arrastrar
      if (REDUCED || !('IntersectionObserver' in window)) return;
      var start = parseFloat(root.getAttribute('data-vt-start')) || 50;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(root);
          var from = Math.min(96, start + 26);
          var t0 = null, dur = 1100;
          function step(ts) {
            if (tocado) return; // si ya lo esta arrastrando, no se le mueve debajo
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var v = from + (start - from) * eased;
            set(v);
            range.value = v;
            if (p < 1) requestAnimationFrame(step);
          }
          if (tocado) return;
          set(from);
          range.value = from;
          setTimeout(function () { if (!tocado) requestAnimationFrame(step); }, 260);
        });
      }, { threshold: 0.35 });
      io.observe(root);
    });
  }

  /* ------------------------------------- oferta: cuenta atras a fecha REAL */
  // La fecha de fin la pone el comerciante en el editor. Cuando llega, el
  // bloque desaparece: nunca se reinicia (un contador que se reinicia es
  // publicidad enganosa en la UE).
  function initOffer() {
    document.querySelectorAll('[data-vt-offer]').forEach(function (root) {
      if (!once(root, 'Offer')) return;
      var end = Date.parse(root.getAttribute('data-vt-offer'));
      if (isNaN(end)) return;
      var units = {
        d: root.querySelector('[data-u="d"]'),
        h: root.querySelector('[data-u="h"]'),
        m: root.querySelector('[data-u="m"]'),
        s: root.querySelector('[data-u="s"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      var timer = null;
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          clearInterval(timer);
          root.hidden = true;
          return;
        }
        var s = Math.floor(left / 1000);
        if (units.d) units.d.textContent = pad(Math.floor(s / 86400));
        if (units.h) units.h.textContent = pad(Math.floor((s % 86400) / 3600));
        if (units.m) units.m.textContent = pad(Math.floor((s % 3600) / 60));
        if (units.s) units.s.textContent = pad(s % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ------------------------------ video: no se carga hasta que se pulsa */
  // Solo se descarga la imagen de portada (y en diferido). El video pesa
  // megas: cargarlo con la pagina hundiria la velocidad de carga en movil.
  function initVideo() {
    document.querySelectorAll('[data-vt-video]').forEach(function (root) {
      if (!once(root, 'Video')) return;
      var btn = root.querySelector('.vt-video__play');
      var tpl = root.querySelector('template');
      if (!btn || !tpl) return;
      btn.addEventListener('click', function () {
        root.appendChild(tpl.content.cloneNode(true));
        root.classList.add('is-playing');
        var v = root.querySelector('video');
        if (v) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    });
  }

  /* ------------------ video en bucle: se carga al acercarse y se pausa al salir */
  function initLoopVideo() {
    document.querySelectorAll('[data-vt-loop] video').forEach(function (v) {
      if (!once(v, 'Loop')) return;
      var src = v.getAttribute('data-src');
      if (!src) return;

      // Arranque retrasado: el video empieza pasado ese segundo y el bucle vuelve
      // ahi, no al principio. Sirve para saltarse la entrada del video.
      var start = parseFloat(v.getAttribute('data-start')) || 0;
      // rebobinar: "otra" fuerza la vuelta al punto de inicio (fin del bucle)
      var goStart = function (otra) {
        if (start > 0 && (otra || v.currentTime < start)) {
          try { v.currentTime = start; } catch (e) {}
        }
      };
      var pidiendo = false;
      var play = function (otra) {
        // Con arranque retrasado no se reproduce hasta saber la duracion y estar
        // colocado: si no, se asomaria el principio durante un instante. Y como
        // el video va con preload="none", hay que pedir esos datos a mano: si no,
        // se quedaria esperando para siempre y no arrancaria nunca.
        if (start > 0 && v.readyState < 1) {
          if (!pidiendo) {
            pidiendo = true;
            v.addEventListener('loadedmetadata', function () { pidiendo = false; play(otra); }, { once: true });
            if (v.preload === 'none') { v.preload = 'metadata'; v.load(); }
          }
          return;
        }
        goStart(otra);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };

      if (start > 0) {
        v.removeAttribute('loop');
        v.addEventListener('timeupdate', function () {
          // se rebobina justo antes del final, asi nunca llega a verse la entrada
          if (v.duration && v.currentTime >= v.duration - 0.12) play(true);
        });
        v.addEventListener('ended', function () { play(true); });
      }

      if (REDUCED || !('IntersectionObserver' in window)) {
        // sin movimiento automatico: portada fija y controles para quien quiera verlo
        v.setAttribute('controls', '');
        v.src = src;
        v.addEventListener('loadedmetadata', function () { goStart(false); }, { once: true });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.getAttribute('src')) v.src = src;
            play(false);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(v);
    });
  }

  /* ---------------------------- "Cookie settings": reabrir el consentimiento */
  // Abre el panel de preferencias del banner de cookies de Shopify. Si en esa
  // region el banner no esta activo (no existe window.privacyBanner), lleva a
  // la politica de cookies, donde se explica como gestionarlas.
  function initCookiePrefs() {
    document.querySelectorAll('[data-vt-cookie-prefs]').forEach(function (btn) {
      if (!once(btn, 'Ck')) return;
      btn.addEventListener('click', function () {
        var pb = window.privacyBanner;
        if (pb && typeof pb.showPreferences === 'function') {
          pb.showPreferences();
        } else {
          var to = btn.getAttribute('data-fallback');
          if (to) window.location.href = to;
        }
      });
    });
  }

  /* ----------------------- barra de compra fija cuando el boton se esconde */
  function initSticky() {
    var bar = document.querySelector('[data-vt-sticky]');
    var target = document.querySelector('[data-vt-add]');
    if (!bar || !target || !once(bar, 'Sticky')) return;
    if (!('IntersectionObserver' in window)) return;
    var cta = bar.querySelector('[data-vt-sticky-go]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        // si se puede comprar, envia el mismo formulario de la ficha (misma
        // variante y cantidad); si no, lleva al boton principal
        var form = document.getElementById('vt-buy-form');
        if (form && !target.disabled) {
          e.preventDefault();
          if (form.requestSubmit) form.requestSubmit(target); else target.click();
        }
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // se muestra solo cuando el boton principal ya ha pasado por arriba
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        document.body.style.paddingBottom = past ? bar.offsetHeight + 'px' : '';
      });
    }, { threshold: 0 });
    io.observe(target);
  }

  /* --------------- anadir al carrito sin salir de la ficha (cajon lateral) */
  // El formulario de la ficha es un formulario normal: al enviarlo, el navegador
  // recarga y acaba en la pagina del carrito. Aqui se intercepta para pedirlo por
  // detras y abrir el cajon lateral, que es lo que espera hoy un comprador.
  // Si algo falla (sin conexion, sin stock, tema sin cajon), se deja el envio de
  // siempre: nunca se queda sin anadir el producto.
  function initAddToCart() {
    var form = document.getElementById('vt-buy-form');
    if (!form || !once(form, 'Add')) return;

    if (!window.routes || !window.routes.cart_add_url) return;

    var btn = form.querySelector('[data-vt-add]');

    // El guion del cajon (cart-drawer.js) se carga DESPUES que este, asi que al
    // arrancar el elemento <cart-drawer> todavia no tiene sus metodos. Por eso se
    // busca en el momento del clic, no aqui.
    function cajon() {
      var d = document.querySelector('cart-drawer');
      return d && typeof d.renderContents === 'function' && typeof d.getSectionsToRender === 'function' ? d : null;
    }

    form.addEventListener('submit', function (e) {
      if (btn && btn.disabled) return;
      var drawer = cajon();
      if (!drawer) return; // sin cajon lateral, el envio de siempre
      e.preventDefault();
      if (btn) btn.classList.add('is-loading');

      var datos = new FormData(form);
      var secciones = drawer.getSectionsToRender().map(function (s) { return s.id; });
      datos.append('sections', secciones.join(','));
      datos.append('sections_url', window.location.pathname);

      var normal = function () {
        if (btn) btn.classList.remove('is-loading');
        form.submit(); // como antes: recarga y lleva al carrito
      };

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: datos
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status || !res.sections) { normal(); return; }
          if (btn) btn.classList.remove('is-loading');
          // Si la pagina se cargo con el carrito vacio, el cajon viene marcado como
          // vacio y Dawn esconde su cabecera y la lista. renderContents() no lo
          // quita del propio <cart-drawer>: hay que hacerlo aqui, como hace Dawn en
          // product-form.js. Sin esto, al anadir el PRIMER producto el cajon se abre
          // casi en blanco (con el segundo ya no pasaba, porque la pagina ya se habia
          // cargado con algo dentro).
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(normal);
    });
  }

  /* ------------------- cajon lateral: anadir recomendados y ensanchar */
  // Los dos botones viven dentro del cajon, que Dawn REPINTA entero cada vez que
  // cambia el carrito. Por eso se escucha en el documento (delegacion) en vez de
  // en cada boton: si no, al repintar se perderian los oyentes.
  function initDrawerExtras() {
    if (!once(document.documentElement, 'Drw')) return;

    function cajon() {
      var d = document.querySelector('cart-drawer');
      return d && typeof d.renderContents === 'function' ? d : null;
    }

    document.addEventListener('click', function (e) {
      var wide = e.target.closest ? e.target.closest('[data-vt-drawer-wide]') : null;
      if (wide) {
        var d = document.querySelector('cart-drawer');
        if (!d) return;
        var ancho = d.classList.toggle('vt-drawer--wide');
        wide.setAttribute('aria-pressed', ancho ? 'true' : 'false');
        wide.setAttribute('aria-label', ancho ? wide.getAttribute('data-label-narrow') : wide.getAttribute('data-label-wide'));
        return;
      }

      var add = e.target.closest ? e.target.closest('[data-vt-up-add]') : null;
      if (!add) return;
      var drawer = cajon();
      var id = add.getAttribute('data-variant');
      if (!drawer || !id || add.disabled) return;

      add.disabled = true;
      add.classList.add('is-loading');

      var datos = new FormData();
      datos.append('id', id);
      datos.append('quantity', '1');
      datos.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      datos.append('sections_url', window.location.pathname);

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: datos
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status || !res.sections) throw new Error('no');
          // ver la nota de initAddToCart: el cajon puede seguir marcado como vacio
          drawer.classList.remove('is-empty');
          // el cajon se repinta entero: el boton de esta tarjeta ya no existe
          drawer.renderContents(res);
        })
        .catch(function () {
          // si falla, al menos que no se quede el boton bloqueado
          add.disabled = false;
          add.classList.remove('is-loading');
        });
    });
  }

  /* ------------------------------------------------------------------ arranque */
  function boot() {
    initAddToCart();
    initDrawerExtras();
    initReveal();
    initParallax();
    initMarquee();
    initIngredients();
    initCounters();
    initReviews();
    initAccordion();
    initGallery();
    initQty();
    initVariants();
    initCompare();
    initOffer();
    initVideo();
    initLoopVideo();
    initSticky();
    initCookiePrefs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // el editor de Shopify recarga secciones sueltas: re-inicializar
  document.addEventListener('shopify:section:load', boot);
})();
